import React from 'react';
import './Instructions.css';

function Instructions({ handleClose }) {
  return (
    <div className="instructions-page">
      <button onClick={handleClose} className="close-button">Close</button>
      <h1>Instructions</h1>
      <p>
        This archive uses an interactive map to locate the geographic locations where the video events happened. For this version, we recommend using a computer. We're working on making it work better on mobile devices. If you do use a mobile device, we recommend holding it in the landscape mode for now.
      </p>

      <p>
        You can click on the markers to reveal the video shot there and a description of it. There are also 'cluster markers' with numbers on them. If you click or zoom in on them, the clusters break down into smaller clusters and markers.
      </p>

      <p>
        You can also filter the markers/videos by their publication date, producer, topic, theme, type, and actors (participants). When you do filtering, the number of results shows up on top left and a window shows up on the right that displays the filtered videos' titles and thumbnails. If you click on each thumbnail, you will be directed to the video and its descriptions. You can click Back to go back to the previous window displaying filtered videos or close the window to go back to the map.
      </p>

      <p>
        Any time that you want to see the list of results again, you can just click on the "... results found!" button.
      </p>

      <p>
        On a mobile device, use gestures to move around the map, rotate it, etc. On a computer, you can also use regular game controls (arrow keys & SWADQE keys) for navigation and rotation:
      </p>


      <ul>
        <li>Arrow keys up and down tilt the camera down and up (3D).</li>
        <li>Arrow keys left and right (or Q & E) rotate the map.</li>
        <li>A and D move you left and right horizontally (2D).</li>
        <li>W and S move you up and down vertically (2D).</li>
      </ul>
    </div>
  );
}

export default Instructions;
